import { useTranslation } from 'react-i18next';
import { useCountdown } from '../../hooks/useCountdown';

const TARGET = new Date('2026-07-18T16:30:00-07:00');

interface CellProps {
  value: number;
  label: string;
  ariaUnit: string;
}

function Cell({ value, label, ariaUnit }: CellProps) {
  return (
    <div className="flex flex-col items-center">
      <span
        className="font-serif font-medium text-brand-gold text-4xl sm:text-5xl leading-none tabular-nums"
        aria-label={`${value} ${ariaUnit}`}
      >
        {String(value).padStart(2, '0')}
      </span>
      <span className="mt-2 text-[0.65rem] sm:text-xs font-sans tracking-widest uppercase text-brand-ink/70">
        {label}
      </span>
    </div>
  );
}

export default function Countdown() {
  const { t } = useTranslation();
  const r = useCountdown(TARGET);

  if (r.isPast) {
    return (
      <p className="font-serif italic text-brand-gold text-lg sm:text-xl text-center">
        {t('countdownStory.afterWedding')}
      </p>
    );
  }

  return (
    <div
      aria-live="polite"
      aria-atomic="true"
      className="grid grid-cols-4 gap-3 sm:gap-5 max-w-md mx-auto"
    >
      <Cell value={r.days} label={t('countdownStory.days')} ariaUnit="days remaining" />
      <Cell value={r.hours} label={t('countdownStory.hours')} ariaUnit="hours" />
      <Cell value={r.minutes} label={t('countdownStory.minutes')} ariaUnit="minutes" />
      <Cell value={r.seconds} label={t('countdownStory.seconds')} ariaUnit="seconds" />
    </div>
  );
}
